import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getBonusesConfig() {
    return {
        palette: {
            [PALETTE_IDS.BONUSES]: {
                BONUSES_SECTION_TITLE_TEXT: {
                    fontWeight: FONT.WEIGHT_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                BONUS_ITEM_TITLE_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    fontSize: FONT.SIZE_MEDIUM,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                BONUS_ITEM_STATUS_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                BONUS_ITEM_STEP_TITLE_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                BONUS_ITEM_STEP_STATUS_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                BONUS_ITEM_STEP_NUMBER_LABEL_BG: COLOR.BRAND.FOREGROUND3,
                BONUS_ITEM_STEP_NUMBER_LABEL_TEXT: COLOR.BRAND.BACKGROUND1,
                BONUS_ITEM_PROGRESS_BAR: {
                    PROGRESS_BAR_LINE_COLOR: COLOR.BRAND.BACKGROUND5,
                    PROGRESS_BAR_FILL_LINE_COLOR: COLOR.BRAND.ACCENT1,
                },
            },
        },
    };
}
